import { API_ACCEPT_LANGUAGE, LOCALE_TYPE } from 'src/types/locale';
import { textEn } from './en';
import { textJa } from './ja';
import { textZhCn } from './zh-CN';
import { textZhHk } from './zh-HK';
import { textZhTw } from './zh-TW';

export type LocaleResources = typeof textJa | typeof textEn | typeof textZhHk | typeof textZhTw | typeof textZhCn;

export const text = (locale: LOCALE_TYPE): LocaleResources => {
  switch (locale) {
    case 'zh_tw':
      return textZhTw;

    case 'ja':
      return textJa;

    case 'zh_hk':
      return textZhHk;

    case 'en':
      return textEn;

    case 'zh_cn':
      return textZhCn;

    default:
      return textJa;
  }
};

const localeToApiAcceptLanguageMap: Record<LOCALE_TYPE, API_ACCEPT_LANGUAGE> = {
  [LOCALE_TYPE.JA]: API_ACCEPT_LANGUAGE.JA,
  [LOCALE_TYPE.EN]: API_ACCEPT_LANGUAGE.EN,
  [LOCALE_TYPE.TW]: API_ACCEPT_LANGUAGE.TW,
  [LOCALE_TYPE.HK]: API_ACCEPT_LANGUAGE.HK,
  [LOCALE_TYPE.CN]: API_ACCEPT_LANGUAGE.CN
};

export const mapLocaleToApiAcceptLanguage = (locale: string): API_ACCEPT_LANGUAGE => {
  return localeToApiAcceptLanguageMap[locale as LOCALE_TYPE];
};
